
<span v-if="hasDiscount" class="discountBadge">{{ Math.round((price / insteadOf - 1) * 100) }}%</span>
